var ONETRUST = {
  CATEGORIES: {
    STRICTLY_NECESSARY: 'C0001',
    PERFORMANCE: 'C0002',
    FUNCTIONAL: 'C0003',
    TARGETING: 'C0004',
    YOUTUBE: 'SEU21'
  },
  COUNTRY_LANGUAGE_OBJECT: {
    gb: {
      id: 6,
      code: 'gb',
      defaultLangauge: 'en'
    },
    de: {
      id: 3,
      code: 'de',
      defaultLangauge: 'de'
    },
    fr: {
      id: 5,
      code: 'fr',
      defaultLangauge: 'fr'
    },
    be: {
      id: 20,
      code: 'be',
      defaultLangauge: 'nl'
    },
    nl: {
      id: 8,
      code: 'nl',
      defaultLangauge: 'nl'
    },
    lu: {
      id: 28,
      code: 'lu'
    },
    at: {
      id: 19,
      code: 'at'
    },
    it: {
      id: 7,
      code: 'it',
      defaultLangauge: 'it'
    },
    pt: {
      id: 26,
      code: 'pt',
      defaultLangauge: 'pt'
    },
    es: {
      id: 4,
      code: 'es',
      defaultLangauge: 'es'
    }
  }
};
export default ONETRUST;